import { Routes, RouterModule } from "@angular/router";
import { IDAdminComponent } from "./index";
import { IDDesignComponent } from "./iddesign/iddesign.component";
import { BatchUploadComponent } from "./batchupload/batchupload.component";
import { PhotoMaintComponent } from "./photomaint/photomaint.component";
import { ImageMaintComponent } from "./imagemaint/imagemaint.component";
import { IDPrintComponent } from "./idprint/idprint.component";
import { PrinterMaintComponent } from "./printermaint/printermaint.component";
import { PhotoExportComponent } from "./photoexport/photoexport.component";
import { ClickOnceDeployComponent } from "./clickoncedeploy/clickoncedeploy.component";
import { AuthguardService } from "../master/services";

export const IDAdminRoutes: Routes = [
	{ path: "", redirectTo: "/idadmin/print", pathMatch: "full" },
	{
		path: "design",
		data: { title: "ID Card Design" },
		component: IDDesignComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "batchupload",
		data: { title: "Batch Photo Upload" },
		component: BatchUploadComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "photomaint",
		data: { title: "Person Photo Maintenance" },
		component: PhotoMaintComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "imagemaint",
		data: { title: "Image Library Maintenance" },
		component: ImageMaintComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "print",
		data: { title: "ID Card Printing" },
		component: IDPrintComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "printermaint",
		data: { title: "ID Card Printer Maintenance" },
		component: PrinterMaintComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "photoexport10",
		data: { title: "Photo Exports" },
		component: PhotoExportComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "clkoncedply",
		data: { title: "Click-Once Deploy (SU Only)" },
		component: ClickOnceDeployComponent,
		canActivate: [AuthguardService],
	},
];
